import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
	providedIn: 'root'
})
export class PrivilegeIndicatorService {
	constructor(private http: HttpClient,
		private cookieService: CookieService ) { }
	removePrivileges() {
		let headers = new HttpHeaders().set('X-LogBook-Remove-Privileges', '*');
		this.cookieService.delete('force-log-admin', '/');
		return this.http.get('/api/user', {
			headers: headers
		});
	}
}
